import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-property-container',
  templateUrl: './view-property-container.component.html',
  styleUrls: ['./view-property-container.component.scss']
})
export class ViewPropertyContainerComponent implements OnInit {
  @Input()
  property;

  @Input()
  attributes;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  goToProperty() {
    if (this.property && this.property.id) {
      this.router.navigate(['view-property', this.property.id]);
    }
  }

}
